<template>
	<app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Onboarding">
        <template #header>
            Onboarding
        </template>


        <div class="h-screen flex flex-1 items-center justify-center">
        	<onboarding />
        </div>
    </app-layout>
</template>

<script>
	import AppLayout from '@/Layouts/Layout'
	import Onboarding from '@/Global/Onboarding/Onboarding.vue'

	export default {
		setup(props) {



		},

		components: {
			AppLayout,
		}
	}
</script>